import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Menu from '../../components/Menu';
import { setLBControlStatusUpdated } from '../../features/App/actions';
import { actions as applicationActions } from '../../features/Application';
import store from '../store';

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changePage: page => push(page),
      inactivateApplication: applicationActions.inactivateApplication,
    },
    dispatch
  );

const mapStateToProps = state => {
  function checkLBControlStatus(stateStatus) {
    if (stateStatus !== null) return stateStatus;

    let done = true;

    // forms
    if (
      done &&
      (state.status.member1 !== 'APPROVED' &&
        state.status.member1 !== 'UPDATED')
    )
      done = false;
    if (
      done &&
      state.application.showMember2 &&
      (state.status.member2 !== 'APPROVED' &&
        state.status.member2 !== 'UPDATED')
    )
      done = false;
    if (
      done &&
      (state.status.apartment1 !== 'APPROVED' &&
        state.status.apartment1 !== 'UPDATED')
    )
      done = false;
    if (
      done &&
      state.application.showApartment2 &&
      (state.status.apartment2 !== 'APPROVED' &&
        state.status.apartment2 !== 'UPDATED')
    )
      done = false;
    if (
      done &&
      (state.status.swapReason !== 'APPROVED' &&
        state.status.swapReason !== 'UPDATED')
    )
      done = false;
    if (
      done &&
      (state.status.details1 !== 'APPROVED' &&
        state.status.details1 !== 'UPDATED')
    )
      done = false;
    if (
      done &&
      state.application.showApartment2 &&
      (state.status.details2 !== 'APPROVED' &&
        state.status.details2 !== 'UPDATED')
    )
      done = false;
    // documents
    if (
      done &&
      (state.status.minUc !== 'APPROVED' && state.status.minUc !== 'UPDATED')
    )
      done = false;
    if (
      done &&
      (state.status.proofOfId !== 'APPROVED' &&
        state.status.proofOfId !== 'UPDATED')
    )
      done = false;
    if (
      done &&
      (state.status.incomeBase !== 'APPROVED' &&
        state.status.incomeBase !== 'UPDATED')
    )
      done = false;
    if (
      done &&
      (state.status.rentalAgreement !== 'APPROVED' &&
        state.status.rentalAgreement !== 'UPDATED')
    )
      done = false;
    if (
      done &&
      (state.status.rentalBase !== 'APPROVED' &&
        state.status.rentalBase !== 'UPDATED')
    )
      done = false;

    if (done) {
      store.dispatch(setLBControlStatusUpdated());
      return 'UPDATED';
    }
    return null;
  }

  return {
    location: state.router.location,
    showMember2: state.application.showMember2,
    showApartment2: state.application.showApartment2,
    member1Status: state.status.member1,
    member2Status: state.status.member2,
    apartment1Status: state.status.apartment1,
    apartment2Status: state.status.apartment2,
    details1Status: state.status.details1,
    swapReasonStatus: state.status.swapReason,
    minUc: state.status.minUc,
    proofOfId: state.status.proofOfId,
    incomeBase: state.status.incomeBase,
    rentalAgreement: state.status.rentalAgreement,
    rentalBase: state.status.rentalBase,
    LBControl: checkLBControlStatus(state.status.LBControl),
    sign: state.status.sign,
    applicationStatus: state.application.application.status,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Menu);



// WEBPACK FOOTER //
// ./src/features/Menu/index.js